import type { ApiError } from '@condo/contracts';

export class ApiRequestError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: ApiError,
  ) {
    super(body.title || `HTTP ${status}`);
    this.name = 'ApiRequestError';
  }
}

export function humanizeApiError(err: unknown): string {
  if (err instanceof ApiRequestError) {
    if (err.body.detail) return err.body.detail;
    return err.body.title;
  }
  if (err instanceof Error) return err.message;
  return 'Ocurrio un error inesperado.';
}
